import { Navigate, useLocation } from "react-router-dom";

/** Map legacy `?secret=` to `?auth_token=` when redirecting to /admin */
function adminSearchFromLegacy(search) {
  const params = new URLSearchParams(search || "");
  const secret = params.get("secret");
  if (secret && !params.get("auth_token")) {
    params.delete("secret");
    params.set("auth_token", secret);
  }
  const q = params.toString();
  return q ? `?${q}` : "";
}

export function OpsToAdminRedirect() {
  const location = useLocation();
  return (
    <Navigate to={`/admin${adminSearchFromLegacy(location.search)}`} replace />
  );
}

export function AdminDashboardRedirect() {
  const location = useLocation();
  return (
    <Navigate to={`/admin${adminSearchFromLegacy(location.search)}`} replace />
  );
}
